import type { ButtonGroupProps } from 'react-multi-carousel';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';
import type { Products_content_listProducts_wizard_sizeStep_carouselImages } from '@/queries/types/Products';

import SlideshowThumbnail from './SlideshowThumbnail';

export interface SlideShowNavProps extends ButtonGroupProps {
  readonly images: (Products_content_listProducts_wizard_sizeStep_carouselImages | null)[];
  readonly onChange: (idx: number) => void;
}

interface CurrentTarget {
  currentTarget: {
    value: string;
  };
}

export const SlideshowNavigation = ({
  carouselState,
  images,
  goToSlide,
  onChange,
}: SlideShowNavProps): JSX.Element => {
  const currentSlideIndex = carouselState?.currentSlide;

  const handleChange = ({ currentTarget }: CurrentTarget) => {
    const nextSlideIndex = Number(currentTarget.value);
    onChange(nextSlideIndex);
    goToSlide?.(nextSlideIndex);
  };

  const mobileMaxWidthPercent = 25 * images.length;
  const mobileBtnMaxWidth = 0.15 * mobileMaxWidthPercent;

  return (
    <div
      className="absolute inset-x-0 bottom-4 mx-auto my-0 mt-6 flex flex-1 gap-2 md:max-w-sm"
      style={{ maxWidth: `${mobileBtnMaxWidth}rem` }}
    >
      {images.map((props, idx: number) => {
        if (!props) return null;
        const { altMsgKey, originalSrc, thumbnailSrc } = props;
        const src =
          thumbnailSrc && thumbnailSrc.length > 0 ? thumbnailSrc : originalSrc;

        return (
          <SlideshowThumbnail
            data-cy={`pdp-slideshow-thumbnail-${idx}`}
            data-selected={currentSlideIndex === idx}
            image={
              <Image
                priority
                localizedAlt={altMsgKey as MessageKey}
                src={src}
                width={46}
                height={34.5}
              />
            }
            index={idx}
            isSelected={currentSlideIndex === idx}
            key={`pdp-slideshow-thumbnail-${altMsgKey}`}
            onClick={handleChange}
          />
        );
      })}
    </div>
  );
};

export default SlideshowNavigation;
